import React from 'react'

function Logo() {
  return (
    <div>
        <img src='/amaljce.png' alt="Logo" className="img-fluid" style={{ maxHeight: '150px', maxWidth: '170px' }} />
    </div>
  )
}

export default Logo